<template>
    <div class="guide-text-wrapper">
        <TextEditor class="textarea" tag="span" ref="textInput" maxlength="2000" @input="inputChange" :dataValue="data.content" />
    </div>
</template>

<script>
import TextEditor from "@/views/zhiji/components/questionEdit/answers/widgets/textItem/TextEditor";

export default {
    name: "GuideText",
    props: ["data"],
    components: {
        TextEditor
    },
    methods: {
        inputChange(data) {
            let newData = Object.assign({}, this.data, {
                content: data.text,
                updateState: "update"
            });

            this.$emit("updateContent", newData);
        }
    }
};
</script>

<style lang="scss" scoped>
.guide-text-wrapper {
    position: relative;
    background: #fafbfd;
    border: 1px solid #d8e4f0;
    border-radius: 4px;

    & > .textarea {
        padding: 10px 10px 0;
        width: 500px;
        height: 191px;
        background: transparent;
        vertical-align: top;
        padding-bottom: 24px;
    }
}
</style>
